import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Judge from './Judge';

export default class LeaderboardScoreJudges extends Component {
  static propTypes = {
    scoreStyle: PropTypes.object.isRequired,
    colors: PropTypes.object.isRequired,
    runs: PropTypes.object.isRequired,
    roundConfig: PropTypes.object.isRequired,
  };

  render() {
    const {
      scoreStyle,
      athlete,
      colors,
      runs: { values = [] },
      roundConfig,
    } = this.props;

    if (!values) {
      return null;
    }

    const { mostRunsCount } = roundConfig;
    const runs = [...values].splice(0, mostRunsCount);

    while (runs.length < mostRunsCount) {
      runs.push({ dummy: true });
    }

    if (!runs.length) {
      return null;
    }

    return runs.map((run, i) => (
      <Judge
        key={`leaderboard_judge_scores_${athlete.externalId}_${i}`}
        groupKey={i}
        judges={run.judges}
        scoreStyle={scoreStyle}
        athlete={athlete}
        colors={colors}
        roundConfig={roundConfig}
      />
    ));
  }
}
